export default __webpack_public_path__ + "static/media/blog_detail5.b3c6eaab.webp";